import { render, staticRenderFns } from "./MonthlyRecurringCharges.vue?vue&type=template&id=a5ca12f0&scoped=true"
import script from "./MonthlyRecurringCharges.vue?vue&type=script&lang=js"
export * from "./MonthlyRecurringCharges.vue?vue&type=script&lang=js"
import style0 from "./MonthlyRecurringCharges.vue?vue&type=style&index=0&id=a5ca12f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca12f0",
  null
  
)

export default component.exports